export const getActiveFiltersFromParams = (params: URLSearchParams) => {
  const filters = Array.from(params.keys()).filter(param => param.startsWith('filter_'));

  const filterMap = new Map<string, string[]>();
  for (const filter of filters) {
    filterMap.set(filter, params.getAll(filter));
  }
  return Object.fromEntries(filterMap);
};
